export const MAX_COURSE_PREFERENCES = 100;
